/**
 * Decides whether a region tag is in-scope for the current project.
 * Mirrors the per-region filter used by DigitalModelComponent:
 *   • "Global"       → always shown
 *   • "UK"           → only when `ukEnabled`
 *   • "Indonesia"    → only when `indonesiaEnabled`
 *   • "Gorontalo"    → only when `indonesiaEnabled`
 *   • undefined / "" → always shown (no scope claimed)
 *   • anything else  → shown by default (unknown regions are kept rather
 *                       than silently hidden, so introducing a new region
 *                       doesn't require code changes here)
 */
export function isRegionAvailable(
  region: string | undefined,
  permissions: { ukEnabled?: boolean; indonesiaEnabled?: boolean } | undefined
): boolean {
  if (!region) return true
  if (!permissions) return true
  const normalized = region.trim().toLowerCase()
  if (normalized === "global") return true
  if (normalized === "uk") return !!permissions.ukEnabled
  if (normalized === "indonesia" || normalized === "gorontalo") return !!permissions.indonesiaEnabled
  return true
}

